import React, { Component } from 'react';
import TableData from '../component/TableData.js';
import TableHead from '../component/TableHead.js';
import axios from 'axios';
import {path,report} from './routes.js';
import checkmark from '../asset/img/checkmark.png';
import denied from '../asset/img/denied.png';
import Modal from 'react-modal';
import SelectBox from '../component/Select.js';

export default class ViewOrders extends Component{
	constructor(props){
		super(props);
		this.state = {orders:[],modalIsOpen:false,cancelID:0,modalPrompt:'',view:'Pending'};
		this.getOrders = this.getOrders.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
		this.cancelOrder = this.cancelOrder.bind(this);
		this.changeStatus = this.changeStatus.bind(this);
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.onclick = this.onclick.bind(this);
		this.handleSelect = this.handleSelect.bind(this);
		this.downloadReport = this.downloadReport.bind(this);
	}

	getOrders(){ //method that retrieves all order information, different information depending on user_type
		let parameters;
		if(this.props.userInfo.userType !== "admin"){ //if not admin, grab all orders that the user has submitted
			parameters = {endpoint:'info',table:'orders',action:'history',kind:this.props.app,userID:this.props.userInfo.userID};
		}else{ //if the user is an admin, there will be two different sets of data depending on if the admin would like to see pending orders or order history
			if(this.state.view === "Pending"){ //this is for viewing all pending orders
				parameters = {endpoint:'info',table:'orders',action:'admin',kind:this.props.app};
			}else if(this.state.view === "Fulfilled"){ //this is for viewing all fulfilled orders
				parameters = {endpoint:'info',table:'orders',action:'admin_history',kind:this.props.app};
			}else if(this.state.view === "Ordered"){
				parameters = {endpoint:'info',table:'orders',action:'ordered'};
			}
		}
		axios({ //retrieve order info
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:parameters
		}).then((response)=>{
			let orderitem = {};
			let orderInfo = [];
			let data = response.data.data;
			data.forEach((item)=>{
				orderInfo.push({ID:item.ID,userID:item.userID,name:item.name,points:item.points,Date:item.Date,status:item.order_status,items:[]});
			});
			let orders = orderInfo.filter(obj => !orderitem[obj.ID] && (orderitem[obj.ID] = true));
			orders.forEach((order)=>{ //consolidate orders and their line items
				data.forEach((orderItem)=>{
					if(orderItem.ID === order.ID){
						let orderSize = orderItem.size === null?"N/A":orderItem.size;
						let orderColor = orderItem.color === null?"N/A":orderItem.color;
						order.items.push({prize:orderItem.prize,cost:orderItem.item_points,quantity:orderItem.quantity,size:orderSize,color:orderColor.replace(/_/g," ")});
					}
				});
			});
		this.setState({orders:orders});
		});
	}

	componentDidMount(){ //when component mounts, call getOrders()
		this.getOrders();
	}

	handleCancel(e){ //method that begins the process of canceling an order
		let orderID = e.currentTarget.name;
		this.setState({cancelID:orderID},function(){
			this.openModal();
		});
	}

	componentDidUpdate(prevProps,prevState){ //get new order information 
		if(prevProps.submitted !== this.props.submitted){
			this.getOrders();
		}
	}

	changeStatus(status,id,date,quantity,userID){ //method for changing the status of an order (fulfilled,canceled, or denied)
		axios({
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'create',table:'orders',misc:'status',status:status,firstID:id,secondID:userID,date:date,quantity:quantity}
		}).then((response)=>{
			if(status === "cancel" || "denied"){
				this.setState({modalPrompt:"Order Canceled!"});
				if(this.props.userInfo.userType !== "admin"){ //if a user cancels an order, refund their points
					this.props.redeemable("add",quantity);
				}
			}else{
				this.setState({modalPrompt:"Order Fulfilled!"});
			}
			this.props.logChange();
		});
	}

	onclick(e){ //method that handles click of cancel, fulfill, or deny buttons
		let val = e.currentTarget.value;
		let orderID = e.currentTarget.name;
		let date;
		let quantity;
		let userID;
		if(val === "cancel"){ //if user is choosing to cancel their order
			this.setState({cancelID:orderID},function(){
				this.openModal();
			});
		}else{ //admin chose to fulfill or deny order
			
			const newOrders = [];
			this.state.orders.forEach((order)=>{
				if(Number(order.ID) !== Number(orderID)){
					newOrders.push(order);
				}else{
					date = order.Date;
					quantity = order.points;
					userID = (this.props.userInfo.userType !== "admin")?this.props.userInfo.userID:order.userID;
				}
			});
			this.changeStatus(val,orderID,date,quantity,userID);
			this.setState({orders:newOrders});
		}
	}

	handleSelect(identity,value){ //method for handling admin view selection (view pending or view history)
		this.setState({view:value},function(){
			this.getOrders();
		});
	}

	openModal() { //open the modal
    this.setState({modalIsOpen: true});
  }

	closeModal() { //close the modal
	    this.setState({modalIsOpen: false,modalPrompt:''});
	}

	cancelOrder(){ //method that performs necessary operations for canceling an order
		let date;
		const {orders,cancelID} = this.state;
		const newOrders = [];
		let quantity;
		let userID;
		orders.forEach((order)=>{ //filter out order to be cancelled
			if(Number(order.ID) !== Number(cancelID)){
				newOrders.push(order);
			}else{
				date = order.Date;
				quantity = order.points;
				userID = (this.props.userInfo.userType !== "admin")?this.props.userInfo.userID:order.userID;
			}
		});
		this.setState({orders:newOrders});
		this.changeStatus("cancel",cancelID,date,quantity,userID);
	}

	downloadReport(){
		window.location.href = report+"/?endpoint=order_report";
	}

	render(){
		let content;
		let columnthree;
		const customStyles = {
		  content : {
		    top: '50%',
		    left: '50%',
		    right: 'auto',
		    bottom: 'auto',
		    width:'400px',
		    minWidth:'300px',
		    borderStyle:'solid',
		    borderWidth:'2px',
		    borderColor:'gray',
		   // backgroundColor:'#F4F4F4',
		    transform: 'translate(-50%, -50%)',
		    boxShadow:'0.5px 0.5px 1px 0.5px'
			}, 
			overlay:{
				backgroundColor:'rgba(105,105,105,0.8)'
			}
		};
		const approve = {
			backgroundImage: 'url('+checkmark+')',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center',
			backgroundColor: 'white',
			backgroundSize: '35px 25px',
			minWidth: '40px',
			minHeight:'30px'
		};
		const deny = {
			backgroundImage: 'url('+denied+')',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center',
			backgroundColor: 'white',
			backgroundSize: '35px 25px',
			minWidth: '40px',
			minHeight:'30px'
		};
		const orders = this.state.orders;
		let viewDrop;
		let pStyle;
		const selectStyles = "w-100 br2 bw1 truncate shadow-3 viewOrders tc center";
		const columnHeads = ["Prize","Unit Cost","Quantity","Size","Color"];
		const orderhistory = orders.map((orders,i)=>{ //map out all order information
			const items = orders.items;
			const orderitems = items.map((items,i)=>{ //map out each line item for each order
				return (<TableData key={i} columns={items} cellstyle="ba tc pa1" rowstyle="stripe-blue" viewOrders={true}/>)
			});
			if(this.props.userInfo.userType !== "admin"){ //add cancel button for user if order is pending
				if(orders.status === "pending"){
					pStyle = "fl w-25 b";
					columnthree = <div className="fl w-50"><p className="fl w-50 b">Status: {orders.status}</p><div className="fl w-50 tr"><button className="w-100 bg-dark-blue br3 white b h2 mt2 mr2" style={{maxWidth:'110px'}} name={orders.ID} onClick={this.handleCancel}>Cancel</button></div></div>;
				}else{
					pStyle = "fl w-33 b";
					columnthree = <p className={pStyle}>Status: {orders.status}</p>;
				}
			}else{
				if(this.state.view === "Pending" || this.state.view === "Ordered"){ //add buttons for admin to either deny or mark as ordered if pending, mark as fulfilled if ordered.
					if(this.state.view === "Pending"){
						pStyle = "fl w-25 b";
							columnthree = <div className="fl w-50 b"><p className="fl w-50 b">Name: {orders.name}</p><div className="fl w-50 pr2 mt2"><button className="fr br3" name={orders.ID} value="ordered" onClick={this.onclick} style={approve}></button>
														<button className="fr br3" name={orders.ID} value="denied" onClick={this.onclick} style={deny}></button></div></div>;
					}else{
						pStyle = "fl w-25 b"
						columnthree = <div className="fl w-50 b"><p className="fl w-50 b">Name: {orders.name}</p><div className="fl w-50 pr2 mt2"><button className="fr br3" name={orders.ID} value="fulfilled" onClick={this.onclick} style={approve}></button></div></div>;
					}
				}else{
					pStyle = "fl w-25 b"
					columnthree = <div className="fl w-50">
													<p className="fl w-50 b">Name: {orders.name}</p>
													<p className="fl w-50 b">Status: {orders.status}</p>
												</div>;
				}
			}
			return(
				<div className="fl w-100 mv3 br3 shadow-3 bg-white" key={i}>
					<div className="fl w-100 ba br--top br3 br bl pl2">
						<p className={pStyle}>Date: {orders.Date}</p>
						<p className={pStyle}>Points: {orders.points}</p>
						{columnthree}
					</div>
					<table className="fl w-100 collapse">
						<thead className="collapse">
							<TableHead columns={columnHeads} headstyle="ba pa2"/>
						</thead>
						<tbody>
							{orderitems}
						</tbody>
					</table>
				</div>
			)
		});
		let order_report_button;
		let item_report_button;
		let order_report_href;
		let item_report_href;
		let item_report_button_name;
		let order_report_button_name;
		if(this.props.userInfo.userType === "admin"){ //dropdown menu to view pending orders or order history for admin
			if(this.state.view !== "Pending"){
				if(this.state.view === "Ordered"){
					item_report_href = report+"/?endpoint=item_report";
					order_report_href = report+"/?endpoint=order_report";
					item_report_button_name = "Item Report";
					order_report_button_name = "Order Report";
				}else{
					item_report_href = report+"/?endpoint=YTD_item_report";
					order_report_href = report+"/?endpoint=YTD_order_report";
					item_report_button_name = "YTD Item Report";
					order_report_button_name = "YTD Order Report";
				}
				let buttonClasses = "br3 shadow-3 bg-dark-blue white ba pa2 no-underline b b--dark-blue reportButtons";
				let buttonStyle = {display:'inline-block',minWidth:'100%',textAlign:'center'};
				//report_download_button = <input type="button" value="Download Report" onClick={this.downloadReport} className="pa1 h2 pl2 pr2 bg-blue white b br2 shadow-3"/>;
				item_report_button = <a href={item_report_href} target="_self" download className={buttonClasses} style={buttonStyle}>{item_report_button_name}</a>
				order_report_button = <a href={order_report_href} target="_self" download className={buttonClasses} style={buttonStyle}>{order_report_button_name}</a>
			}
			viewDrop = <div className="fc w-100 mb4">
										<div className="fc w-100 tc">
											<div className="fc w-100 tc" style={{maxWidth:'335px',margin:'auto'}}>
												<SelectBox options={["Pending","Ordered","Fulfilled"]} id="viewOrders" styles={selectStyles} val={this.state.view} onSelect={this.handleSelect}/>
											</div>
											<div className="fc w-100 tc pt3" style={{maxWidth:'335px',margin:'auto'}}>
												<div className="fl w-50 pr1">
													{item_report_button}
												</div>
												<div className="fl w-50 pl1">
												{order_report_button}
												</div>
											</div>
										</div>
									</div>;
		}
		if(this.props.active){
			if(orders.length !== 0){
				content = <div>
										{viewDrop}
										{orderhistory}
									</div>
			}else{
				content = <div>
										{viewDrop}
										<p className="fl w-100 f3 tc mt3">There is nothing to view at this time.</p>
									</div>;
			}
		}
		let modalContent;
		if(this.state.modalPrompt !== ''){ //display message
			modalContent = <p className="b navy tc f4">{this.state.modalPrompt}</p>;
		}else{ //display prompt for canceling an order
			modalContent = <div className="fl w-100">
						        	<div>
						        		<p>Are you sure you would like to cancel this order?</p>
						        	</div>
						        	<div className="fl w-100">
						        		<div className="fl w-50 tc">
						        			<button onClick={this.cancelOrder} className="w-50-ns w-100 bg-navy b white br2">Yes</button>
						        		</div>
						        		<div className="fl w-50 tc">
						        			<button onClick={this.closeModal} className="w-50-ns w-100 bg-navy b white br2">No</button>
						        		</div>
						        	</div>
						        </div>
		}
		return (
			<div>
				{content}
				<Modal
	          isOpen={this.state.modalIsOpen}
	          style={customStyles}
	          contentLabel="order cancel"
	          shouldCloseOnOverlayClick={false}
	          shouldCloseOnEsc={false}
	        >
	        <div className="fl w-100 tr">
	        	<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
	        </div>
	        {modalContent}
	        </Modal>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/ViewOrders.js